import { render, staticRenderFns } from "./crudLeads.vue?vue&type=template&id=3f141e07&scoped=true&"
import script from "./crudLeads.vue?vue&type=script&lang=js&"
export * from "./crudLeads.vue?vue&type=script&lang=js&"
import style0 from "./crudLeads.vue?vue&type=style&index=0&lang=css&"
import style1 from "./crudLeads.vue?vue&type=style&index=1&lang=css&"
import style2 from "./crudLeads.vue?vue&type=style&index=2&id=3f141e07&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f141e07",
  null
  
)

export default component.exports